import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '~/core/app.module';

// Production mode should be determined by the actual build output
// Uncomment if needed for specific production build handling
// const isProduction = !location.hostname || location.hostname === 'localhost' === false;
// if (isProduction) {
//   enableProdMode();
// }

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

